import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=1d633f2f"
import script from "./RequestList.js?vue&type=script&lang=js&external"
export * from "./RequestList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports